/**
 * FRONT-1311: when the "Jump to latest" pill is offered.
 *
 * A reader who has scrolled up is deliberately not dragged back down, so the
 * pill is their only way back to the live end of the thread. It used to appear
 * only while a turn was streaming or waiting — but a turn blocked on a tier-3
 * approval is neither. The autonomy gate holds the tool call server-side and
 * polls (src/autonomy/gate.ts), so nothing streams for up to five minutes while
 * the card the user has to answer sits below the fold with no way to discover
 * it. That is the whole complaint on this ticket: the approval was rendering in
 * chat, invisibly, and only the Inspector's copy could be found.
 *
 * A pending approval therefore counts as a reason to offer the pill, and it is
 * the strongest one: the others are "there is more to read", this one is
 * "nothing continues until you answer".
 *
 * Pure and separate from the component so it can be tested without a DOM —
 * ponytail: a function, not a hook, since it holds no state.
 */
export function shouldShowJumpPill(args: {
  /** False once the reader scrolls up (they are no longer pinned to the floor). */
  autoScroll: boolean;
  isStreaming: boolean;
  isWaiting: boolean;
  /** Approvals raised by this chat that are still awaiting an answer. */
  pendingApprovalCount: number;
}): boolean {
  if (args.autoScroll) return false;
  return args.isStreaming || args.isWaiting || args.pendingApprovalCount > 0;
}
